<template lang="html">
  <section class="section">
    <div class="container">
      <div class="columns is-multiline">
        <div class="column is-6">
          <h1 class="title">Bug</h1>
          <figure class="image is-4by3">
            <img class="zoom-default" data-zoom-src="static/images/bug/bug_06.jpg" src="static/images/bug/bug_06.jpg">
          </figure>
        </div>
        <div class="column is-6" style="margin-top: 55px;">
          <p class="title">Bug furniture series plays with the elements of a classic Safari chair. </p>
          <p>
            It’s a combination of light organic frame shape and great soft cushions.
            The series consists of two heights of a lounge chair and a footstool that are all available in several upholstery options.
            The cushions and the upholstered parts are easy to remove and to update, if needed, to make the maintenance effortless and to extend the product's lifetime.
            Produced by Interface, Finland.
          </p>
          <br>
          <p>Photography: Martti Järvi / Interface</p>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/bug/bug_05.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img src="static/images/bug/bug_03-higres.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img class="zoom-default" data-zoom-src="static/images/bug/bug_01.jpg" src="static/images/bug/bug_01.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img class="zoom-default" data-zoom-src="static/images/bug/bug_02.jpg" src="static/images/bug/bug_02.jpg">
          </figure>
        </div>
        <div class="column is-6">
          <figure class="image">
            <img class="zoom-default" data-zoom-src="static/images/bug/bug_04.jpg" src="static/images/bug/bug_04.jpg">
          </figure>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import mediumZoom from 'medium-zoom'

export default {
  mounted () {
    mediumZoom('.zoom-default', {
      container: {
        top: 150
      }
    })
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/portfolio/work/Bug.vue